import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { installHistoryTraversalGuard } from './utils/historyTraversalGuard';

// Must run before the router mounts so unsaved-change guards see Back/Forward first.
installHistoryTraversalGuard();

// Chosen at build time so the app ships in the initial bundle instead of loading after it.
// The sample player never runs ordinary routes, auth bootstrap or analytics.
const App: React.ComponentType = process.env.REACT_APP_ENVIRONMENT === 'staging' && process.env.REACT_APP_THEME_STUDIO_DEMO === 'true'
  ? require('./themeStudioDemo/ThemeStudioDemoApp').default
  : require('./App').default;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
